module.exports = __webpack_public_path__ + "static/img/icon_pro4s.6e2c38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro4s.png
// module id = GjIO
// module chunks = 11